module.exports = __webpack_public_path__ + "static/media/disability-small-placeholder.a49cb815.webp";